// extracted by mini-css-extract-plugin
export default {"link":"Link_link__Qp094","linkPopup":"Link_linkPopup__vd88Z","popupWrapper":"Link_popupWrapper__u9fSp","popup":"Link_popup__rB7db","button":"Link_button__-zDxR"};